/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Filter_UnreadInputs */

const en_notifications_filter_unread = /** @type {(inputs: Notifications_Filter_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unread`)
};

const pl_notifications_filter_unread = /** @type {(inputs: Notifications_Filter_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieprzeczytane`)
};

/**
* | output |
* | --- |
* | "Unread" |
*
* @param {Notifications_Filter_UnreadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_filter_unread = /** @type {((inputs?: Notifications_Filter_UnreadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Filter_UnreadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_filter_unread(inputs)
	return en_notifications_filter_unread(inputs)
});